// src/components/PagosModule.js
import React, { useEffect, useMemo, useRef, useState } from 'react';

const SUPABASE_URL = 'https://ubfkhtkmlvutwdivmoff.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InViZmtodGttbHZ1dHdkaXZtb2ZmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTA4MTc5NTUsImV4cCI6MjA2NjM5Mzk1NX0.c0iRma-dnlL29OR3ffq34nmZuj_ViApBTMG-6PEX_B4';

const textoMayusculas = (valor = '') =>
  String(valor || '').trim().toUpperCase();

function fmtMoney(n) {
  return new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(Number(n || 0));
}
function toDateInput(d) {
  if (!d) return '';
  const dt = new Date(d);
  const y = dt.getFullYear();
  const m = String(dt.getMonth() + 1).padStart(2, '0');
  const day = String(dt.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}
// Genera 'YYYY-MM-DDTHH:MM:SS' en HORA LOCAL (sin 'Z' ni zona)
function localPlainDateTime() {
  const d = new Date();
  const y = d.getFullYear();
  const M = String(d.getMonth() + 1).padStart(2, '0');
  const D = String(d.getDate()).padStart(2, '0');
  const h = String(d.getHours()).padStart(2, '0');
  const m = String(d.getMinutes()).padStart(2, '0');
  const s = String(d.getSeconds()).padStart(2, '0');
  return `${y}-${M}-${D}T${h}:${m}:${s}`;
}
const MONTHS = [
  'Enero','Febrero','Marzo','Abril','Mayo','Junio',
  'Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'
];

function fmtLongDate(s) {
  if (!s) return '';

  let d;

  if (typeof s === 'string' && s.length <= 10) {
    d = new Date(`${s}T00:00:00`);
  } else {
    d = new Date(s);
  }

  return d.toLocaleDateString('es-MX', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  });
}

function fmtFechaHoraLarga(valor) {
  if (!valor) return '';

  const d = new Date(valor);

  const fecha = d.toLocaleDateString('es-MX', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  });

  const hora = d.toLocaleTimeString('es-MX', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
  });

  return (
    fecha.charAt(0).toUpperCase() +
    fecha.slice(1) +
    ', ' +
    hora
  );
}

function fmt12h(valor) {
  if (!valor) return '';

  return fmtFechaHoraLarga(valor);
}

const PagosModule = ({ idSocio }) => {
  // ---------- TARJETAS (SIN CAMBIOS) ----------
  const [loading, setLoading] = useState(true);
  const [dashError, setDashError] = useState(null);

  const [pendientesHoy, setPendientesHoy] = useState(0);
  const [proximos, setProximos] = useState(0);
  const [recibidosHoyCount, setRecibidosHoyCount] = useState(0);
  const [recibidosHoyMonto, setRecibidosHoyMonto] = useState(0);
  const [vencidos, setVencidos] = useState(0);
  const [showVencidosModal, setShowVencidosModal] =
  useState(false);

const [pagosVencidosList, setPagosVencidosList] =
  useState([]);

const [loadingVencidos, setLoadingVencidos] =
  useState(false);

const [errorVencidos, setErrorVencidos] =
  useState('');

const [prestamoVencidoAbierto, setPrestamoVencidoAbierto] =
  useState(null);

const [detalleVencidoAbierto, setDetalleVencidoAbierto] =
  useState(null);

  useEffect(() => {
    (async () => {
      try {
        const now = new Date();
        const hoy = toDateInput(now);
        const d1 = toDateInput(new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1));
        const d2 = toDateInput(new Date(now.getFullYear(), now.getMonth(), now.getDate() + 2));
        const d3 = toDateInput(new Date(now.getFullYear(), now.getMonth(), now.getDate() + 3));

        const r1 = await fetch(
          `${SUPABASE_URL}/rest/v1/pagos_prestamos?fecha_programada=eq.${hoy}&estatus=eq.pendiente&select=id_pago`,
          { headers: { apikey: SUPABASE_ANON_KEY, Authorization: `Bearer ${SUPABASE_ANON_KEY}`, Prefer: 'count=exact', 'Range-Unit': 'items', Range: '0-0' } }
        );
        const c1 = parseInt(r1.headers.get('content-range')?.split('/')?.[1] || '0', 10);
        setPendientesHoy(c1);

        const r2 = await fetch(
          `${SUPABASE_URL}/rest/v1/pagos_prestamos?or=(fecha_programada.eq.${d1},fecha_programada.eq.${d2},fecha_programada.eq.${d3})&estatus=eq.pendiente&select=id_pago`,
          { headers: { apikey: SUPABASE_ANON_KEY, Authorization: `Bearer ${SUPABASE_ANON_KEY}`, Prefer: 'count=exact', 'Range-Unit': 'items', Range: '0-0' } }
        );
        const c2 = parseInt(r2.headers.get('content-range')?.split('/')?.[1] || '0', 10);
        setProximos(c2);

        const r3 = await fetch(
          `${SUPABASE_URL}/rest/v1/pagos_prestamos?fecha_pago=eq.${hoy}&select=monto_pagado`,
          { headers: { apikey: SUPABASE_ANON_KEY, Authorization: `Bearer ${SUPABASE_ANON_KEY}` } }
        );
        const data3 = await r3.json();
        setRecibidosHoyCount(data3.length);
        setRecibidosHoyMonto(data3.reduce((s, x) => s + Number(x.monto_pagado || 0), 0));

        const r4 = await fetch(
          `${SUPABASE_URL}/rest/v1/pagos_prestamos?fecha_programada=lt.${hoy}&estatus=eq.pendiente&select=id_pago`,
          { headers: { apikey: SUPABASE_ANON_KEY, Authorization: `Bearer ${SUPABASE_ANON_KEY}`, Prefer: 'count=exact', 'Range-Unit': 'items', Range: '0-0' } }
        );
        const c4 = parseInt(r4.headers.get('content-range')?.split('/')?.[1] || '0', 10);
        setVencidos(c4);

        setDashError(null);
      } catch (e) {
        setDashError('No se pudieron cargar las métricas.');
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  // ---------- BUSCAR SOCIO (solo input) + flujo ver préstamos / pago ----------
  const [buscarSocioTerm, setBuscarSocioTerm] = useState('');
  const [sugSocios, setSugSocios] = useState([]);
  const [socioSel, setSocioSel] = useState(null);
  const buscarSocioRef = useRef(null);

  const [prestamosSocio, setPrestamosSocio] = useState([]);
  const [prestamoSel, setPrestamoSel] = useState(null);

  // Modal de pagos programados del préstamo
  const [showPagoModal, setShowPagoModal] = useState(false);
  const [pagosProgramados, setPagosProgramados] = useState([]);
  const [prestamoMeta, setPrestamoMeta] = useState(null); // {monto_solicitado, numero_plazos, interes}

  // Sub-modal: ingresar monto / forma de pago / nota  (+ multa por hoja)
  const [showMontoModal, setShowMontoModal] = useState(false);
  const [pagoTarget, setPagoTarget] = useState(null);
  const [montoIngresado, setMontoIngresado] = useState('');
  const [formaPago, setFormaPago] = useState(''); // 'Efectivo' | 'Transferencia'
  const [formaPagoError, setFormaPagoError] = useState('');

  // NUEVO: Multa por hoja
  const [multaHoja, setMultaHoja] = useState('no'); // 'si' | 'no'
  const [montoMultaHoja, setMontoMultaHoja] = useState('');

  // Nota
  const [nota, setNota] = useState('');

  // Confirmación final
  const [showConfirm, setShowConfirm] = useState(false);
  const [saving, setSaving] = useState(false);

  // Modal ver nota
  const [showNotaModal, setShowNotaModal] = useState(false);
  const [notaTexto, setNotaTexto] = useState('');
  // Historial de pagos del socio
const [showHistorialPagosModal, setShowHistorialPagosModal] =
  useState(false);

const [historialPagosSocio, setHistorialPagosSocio] =
  useState([]);

const [loadingHistorialPagos, setLoadingHistorialPagos] =
  useState(false);

const [errorHistorialPagos, setErrorHistorialPagos] =
  useState('');
  
const [ordenHistorial, setOrdenHistorial] = useState({
  campo: 'fecha',
  direccion: 'desc',
});
  // Sugerencias de socios
  useEffect(() => {
    const run = async () => {
      const t = buscarSocioTerm.trim().toLowerCase();
      if (!t) { setSugSocios([]); return; }
      const r = await fetch(`${SUPABASE_URL}/rest/v1/socios?select=id_socio,nombre,apellido_paterno,apellido_materno`,
        { headers: { apikey: SUPABASE_ANON_KEY, Authorization: `Bearer ${SUPABASE_ANON_KEY}` } });
      const data = await r.json();
      const fil = data.filter(s =>
        String(s.id_socio).includes(t) ||
        `${s.nombre} ${s.apellido_paterno} ${s.apellido_materno}`.toLowerCase().includes(t)
      ).slice(0, 20);
      setSugSocios(fil);
    };
    run();
  }, [buscarSocioTerm]);

  // === NUEVO: cálculo de "Préstamo Liquidado" (misma lógica del módulo Préstamos) ===
  const isPrestamoLiquidado = async (id_prestamo) => {
    try {
      const totalResp = await fetch(
        `${SUPABASE_URL}/rest/v1/pagos_prestamos?id_prestamo=eq.${id_prestamo}&select=count`,
        { headers: { apikey: SUPABASE_ANON_KEY, Authorization: `Bearer ${SUPABASE_ANON_KEY}`, Prefer: 'count=exact', 'Range-Unit': 'items', Range: '0-0' } }
      );
      const totalRange = totalResp.headers.get('content-range') || '0/0';
      const total = parseInt(totalRange.split('/')[1], 10) || 0;

      const pagadosResp = await fetch(
        `${SUPABASE_URL}/rest/v1/pagos_prestamos?id_prestamo=eq.${id_prestamo}&estatus=eq.pagado&select=count`,
        { headers: { apikey: SUPABASE_ANON_KEY, Authorization: `Bearer ${SUPABASE_ANON_KEY}`, Prefer: 'count=exact', 'Range-Unit': 'items', Range: '0-0' } }
      );
      const pagadosRange = pagadosResp.headers.get('content-range') || '0/0';
      const pagados = parseInt(pagadosRange.split('/')[1], 10) || 0;

      return total > 0 && pagados === total;
    } catch {
      return false;
    }
  };

const abrirPagosVencidos = async () => {
  setShowVencidosModal(true);
  setLoadingVencidos(true);
  setErrorVencidos('');
  setPagosVencidosList([]);
  setPrestamoVencidoAbierto(null);
  setDetalleVencidoAbierto(null);

  try {
    const hoy = toDateInput(new Date());

    // ================= PAGOS VENCIDOS =================
    const pagosRes = await fetch(
      `${SUPABASE_URL}/rest/v1/pagos_prestamos?fecha_programada=lt.${hoy}&estatus=eq.pendiente&select=id_pago,id_prestamo,id_socio,numero_pago,fecha_programada,monto_pago,estatus&order=fecha_programada.asc`,
      {
        headers: {
          apikey: SUPABASE_ANON_KEY,
          Authorization: `Bearer ${SUPABASE_ANON_KEY}`,
        },
      }
    );

    if (!pagosRes.ok) {
      const detalle = await pagosRes.text();

      throw new Error(
        `No se pudieron cargar los pagos vencidos: ${detalle}`
      );
    }

    const pagosData = await pagosRes.json();

    if (!pagosData || pagosData.length === 0) {
      setPagosVencidosList([]);
      return;
    }

    // ================= PRÉSTAMOS RELACIONADOS =================
    const prestamosIds = [
      ...new Set(
        pagosData
          .map((pago) => pago.id_prestamo)
          .filter(Boolean)
      ),
    ];

    let prestamosData = [];

    if (prestamosIds.length > 0) {
      const prestamosRes = await fetch(
        `${SUPABASE_URL}/rest/v1/prestamos?id_prestamo=in.(${prestamosIds.join(
          ','
        )})&select=id_prestamo,id_socio,monto_solicitado,numero_plazos,interes,tipo_plazo,estatus`,
        {
          headers: {
            apikey: SUPABASE_ANON_KEY,
            Authorization: `Bearer ${SUPABASE_ANON_KEY}`,
          },
        }
      );

      if (!prestamosRes.ok) {
        const detalle = await prestamosRes.text();

        throw new Error(
          `No se pudieron cargar los préstamos: ${detalle}`
        );
      }

      prestamosData = await prestamosRes.json();
    }

    const prestamosMap = new Map();

    prestamosData.forEach((prestamo) => {
      prestamosMap.set(
        String(prestamo.id_prestamo),
        prestamo
      );
    });

    // Obtener el socio desde pagos_prestamos o desde prestamos
    const sociosIds = [
      ...new Set(
        pagosData
          .map((pago) => {
            const prestamo = prestamosMap.get(
              String(pago.id_prestamo)
            );

            return pago.id_socio || prestamo?.id_socio;
          })
          .filter(Boolean)
      ),
    ];

    // ================= SOCIOS =================
    let sociosData = [];

    if (sociosIds.length > 0) {
      const sociosRes = await fetch(
        `${SUPABASE_URL}/rest/v1/socios?id_socio=in.(${sociosIds.join(
          ','
        )})&select=id_socio,nombre,apellido_paterno,apellido_materno,telefono,email`,
        {
          headers: {
            apikey: SUPABASE_ANON_KEY,
            Authorization: `Bearer ${SUPABASE_ANON_KEY}`,
          },
        }
      );

      if (!sociosRes.ok) {
        const detalle = await sociosRes.text();

        throw new Error(
          `No se pudieron cargar los socios: ${detalle}`
        );
      }

      sociosData = await sociosRes.json();
    }

    const sociosMap = new Map();

    sociosData.forEach((socio) => {
      sociosMap.set(
        String(socio.id_socio),
        socio
      );
    });

    // ================= UNIR INFORMACIÓN =================
    const pagosEnriquecidos = pagosData.map((pago) => {
      const prestamo =
        prestamosMap.get(String(pago.id_prestamo)) ||
        null;

      const idSocioReal =
        pago.id_socio ||
        prestamo?.id_socio ||
        null;

      const socio =
        sociosMap.get(String(idSocioReal)) ||
        null;

      return {
        ...pago,
        id_socio: idSocioReal,
        socio,
        prestamo,
      };
    });

    setPagosVencidosList(pagosEnriquecidos);
  } catch (error) {
    console.error(
      'ERROR CARGANDO PAGOS VENCIDOS:',
      error
    );

    setErrorVencidos(
      error.message ||
        'No se pudieron cargar los pagos vencidos.'
    );
  } finally {
    setLoadingVencidos(false);
  }
};

 const verPrestamos = async () => {
  if (!socioSel) return;

  try {
    setPrestamosSocio([]);
    setPrestamoSel(null);

    const r = await fetch(
      `${SUPABASE_URL}/rest/v1/prestamos?id_socio=eq.${socioSel.id_socio}&select=id_prestamo,monto_solicitado,numero_plazos,interes,tipo_plazo,estatus`,
      {
        headers: {
          apikey: SUPABASE_ANON_KEY,
          Authorization: `Bearer ${SUPABASE_ANON_KEY}`,
        },
      }
    );

    if (!r.ok) {
      throw new Error('No se pudieron consultar los préstamos.');
    }

    const data = await r.json();

    if (!data || data.length === 0) {
      alert('Este socio no cuenta con préstamos actualmente.');
      return;
    }

    const enriched = await Promise.all(
      data.map(async (p) => {
        const liquid = await isPrestamoLiquidado(
          p.id_prestamo
        );

        return {
          ...p,
          isLiquidado:
            liquid ||
            String(p.estatus || '').toUpperCase() ===
              'LIQUIDADO',
        };
      })
    );

    setPrestamosSocio(enriched);
  } catch (error) {
    console.error(
      'Error consultando préstamos:',
      error
    );

    alert(
      error.message ||
        'No se pudieron consultar los préstamos.'
    );
  }
};
const abrirHistorialPagosSocio = async () => {
  if (!socioSel?.id_socio) {
    alert('Primero debe seleccionar un socio.');
    return;
  }

  setShowHistorialPagosModal(true);
  setLoadingHistorialPagos(true);
  setErrorHistorialPagos('');
  setHistorialPagosSocio([]);

  try {
    // Consultar todos los préstamos del socio
    const prestamosRes = await fetch(
      `${SUPABASE_URL}/rest/v1/prestamos?id_socio=eq.${socioSel.id_socio}&select=id_prestamo,monto_solicitado,fecha_solicitud&order=fecha_solicitud.desc`,
      {
        headers: {
          apikey: SUPABASE_ANON_KEY,
          Authorization: `Bearer ${SUPABASE_ANON_KEY}`,
        },
      }
    );

    if (!prestamosRes.ok) {
      const detalle = await prestamosRes.text();

      throw new Error(
        `No se pudieron consultar los préstamos: ${detalle}`
      );
    }

    const prestamosData = await prestamosRes.json();

    if (!prestamosData || prestamosData.length === 0) {
      setHistorialPagosSocio([]);
      return;
    }

    const prestamosIds = prestamosData.map(
      (prestamo) => prestamo.id_prestamo
    );

    // Consultar únicamente pagos realizados
    const pagosRes = await fetch(
      `${SUPABASE_URL}/rest/v1/pagos_prestamos?id_prestamo=in.(${prestamosIds.join(
        ','
      )})&estatus=eq.pagado&select=id_pago,id_prestamo,numero_pago,fecha_programada,fecha_pago,fecha_hora_pago,monto_pago,monto_pagado,interes_pagado,capital_pagado,forma_pago,nota,estatus&order=fecha_hora_pago.desc`,
      {
        headers: {
          apikey: SUPABASE_ANON_KEY,
          Authorization: `Bearer ${SUPABASE_ANON_KEY}`,
        },
      }
    );

    if (!pagosRes.ok) {
      const detalle = await pagosRes.text();

      throw new Error(
        `No se pudo consultar el historial de pagos: ${detalle}`
      );
    }

    const pagosData = await pagosRes.json();

    const prestamosMap = new Map();

    prestamosData.forEach((prestamo) => {
      prestamosMap.set(
        String(prestamo.id_prestamo),
        prestamo
      );
    });

    const historialCompleto = pagosData.map((pago) => ({
      ...pago,
      prestamo:
        prestamosMap.get(String(pago.id_prestamo)) ||
        null,
    }));

    setHistorialPagosSocio(historialCompleto);
  } catch (error) {
    console.error(
      'ERROR CARGANDO HISTORIAL DE PAGOS:',
      error
    );

    setErrorHistorialPagos(
      error.message ||
        'No se pudo consultar el historial de pagos.'
    );
  } finally {
    setLoadingHistorialPagos(false);
  }
};

  const cambiarOrdenHistorial = (campo) => {
  setOrdenHistorial((ordenActual) => {
    if (ordenActual.campo === campo) {
      return {
        campo,
        direccion:
          ordenActual.direccion === 'asc'
            ? 'desc'
            : 'asc',
      };
    }

    return {
      campo,
      direccion:
        campo === 'fecha'
          ? 'desc'
          : 'asc',
    };
  });
};
  
  const abrirRealizarPago = async () => {
    if (!prestamoSel) return;
    const [rp, rmeta] = await Promise.all([
      fetch(
        `${SUPABASE_URL}/rest/v1/pagos_prestamos?id_prestamo=eq.${prestamoSel.id_prestamo}&select=id_pago,numero_pago,fecha_programada,monto_pago,fecha_pago,fecha_hora_pago,monto_pagado,interes_pagado,capital_pagado,estatus,forma_pago,nota&order=numero_pago.asc`,
        { headers: { apikey: SUPABASE_ANON_KEY, Authorization: `Bearer ${SUPABASE_ANON_KEY}` } }
      ),
      fetch(
        `${SUPABASE_URL}/rest/v1/prestamos?id_prestamo=eq.${prestamoSel.id_prestamo}&select=monto_solicitado,numero_plazos,interes`,
        { headers: { apikey: SUPABASE_ANON_KEY, Authorization: `Bearer ${SUPABASE_ANON_KEY}` } }
      )
    ]);
    const pagos = await rp.json();
    const metaArr = await rmeta.json();
    const meta = metaArr?.[0] || null;

    setPrestamoMeta(meta);
    setPagosProgramados(pagos);
    setShowPagoModal(true);
  };

  const onClickRealizarPagoFila = (p) => {
    setPagoTarget(p);
    setMontoIngresado(p.monto_pago || '');
    setFormaPago('');
    setFormaPagoError('');
    setNota('');
    // Inicializar NUEVO estado de multa
    setMultaHoja('no');
    setMontoMultaHoja('');
    setShowMontoModal(true);
  };

const pagarDesdeVencidos = (pago) => {
  if (!pago?.prestamo) {
    alert(
      'No se encontró la información del préstamo correspondiente.'
    );
    return;
  }

  if (!pago?.socio) {
    alert(
      'No se encontró la información del socio correspondiente.'
    );
    return;
  }

  // Preparar al socio seleccionado
  setSocioSel(pago.socio);

  // Preparar el préstamo seleccionado
  setPrestamoSel({
    ...pago.prestamo,
    id_prestamo: pago.id_prestamo,
  });

  // Preparar la información requerida
  // para calcular interés y capital
  setPrestamoMeta({
    monto_solicitado:
      pago.prestamo.monto_solicitado,
    numero_plazos:
      pago.prestamo.numero_plazos,
    interes:
      pago.prestamo.interes,
  });

  // Cerrar el modal de pagos vencidos
  setShowVencidosModal(false);
  setPrestamoVencidoAbierto(null);
  setDetalleVencidoAbierto(null);

  // Abrir el formulario normal de pago
  onClickRealizarPagoFila(pago);
};
  
  const aplicarPago = () => {
    if (!montoIngresado || Number(montoIngresado) <= 0) {
      alert('Indique un monto válido.');
      return;
    }
    if (!formaPago) {
      setFormaPagoError('debe seleccionar su forma de pago');
      return;
    }
    // Validación NUEVA: si multaHoja = 'si', se requiere monto de multa > 0
    if (multaHoja === 'si' && !(Number(montoMultaHoja) > 0)) {
      alert('Indique el monto de la multa por hoja.');
      return;
    }
    setShowConfirm(true);
  };

  // Guardar pago (sin parciales: siempre estatus = "pagado")
  const confirmarAplicacionPago = async () => {
    if (!pagoTarget || !prestamoMeta) return;
    setSaving(true);
    try {
      const monto = Number(montoIngresado);

      // Calcula interés/capital
      const capitalEstimado = Number(prestamoMeta.monto_solicitado) / Number(prestamoMeta.numero_plazos || 1);
      const interesEstimado = Number(prestamoMeta.monto_solicitado) * (Number(prestamoMeta.interes) / 100);
      const interes_pagado = Math.min(monto, interesEstimado);
      const capital_pagado = Math.max(monto - interes_pagado, 0);

      // Fecha/hora local sin 'Z'
      const nowLocalPlain = localPlainDateTime();
      const soloFecha = nowLocalPlain.slice(0, 10);

    const body = {
  fecha_pago: soloFecha,
  fecha_hora_pago: nowLocalPlain,
  estatus: 'pagado',
  monto_pagado: monto,
  interes_pagado,
  capital_pagado,
  forma_pago: formaPago,
  nota: textoMayusculas(nota) || null
};

      const r = await fetch(
        `${SUPABASE_URL}/rest/v1/pagos_prestamos?id_pago=eq.${pagoTarget.id_pago}`,
        {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/json',
            apikey: SUPABASE_ANON_KEY,
            Authorization: `Bearer ${SUPABASE_ANON_KEY}`
          },
          body: JSON.stringify(body)
        }
      );
     if (!r.ok) {
  const detalleError = await r.text();

  console.error(
    'ERROR REGISTRANDO PAGO:',
    detalleError
  );

  throw new Error(
    `No se pudo registrar el pago: ${detalleError}`
  );
}

      // NUEVO: si seleccionó "Multa por hoja = Sí", registrar en pago_multas
      if (multaHoja === 'si' && Number(montoMultaHoja) > 0 && socioSel?.id_socio) {
        try {
          const multaBody = {
            id_socio: socioSel.id_socio,
            multa_hoja: true,
            monto_multa_hoja: Number(montoMultaHoja),
            fecha_hora: nowLocalPlain
          };
          const rMulta = await fetch(`${SUPABASE_URL}/rest/v1/pago_multas`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              apikey: SUPABASE_ANON_KEY,
              Authorization: `Bearer ${SUPABASE_ANON_KEY}`,
              Prefer: 'return=representation'
            },
            body: JSON.stringify(multaBody)
          });
          // Si falla, no bloquea el flujo de pago de préstamo
          if (!rMulta.ok) {
            console.warn('No se pudo registrar la multa por hoja.');
          }
        } catch (e) {
          console.warn('Error registrando multa por hoja:', e?.message || e);
        }
      }

      // Refrescar lista del modal
      await abrirRealizarPago();

      // Cerrar sub-modales y limpiar
      setShowConfirm(false);
      setShowMontoModal(false);
      setPagoTarget(null);
      setMontoIngresado('');
      setFormaPago('');
      setNota('');
      setMultaHoja('no');
      setMontoMultaHoja('');
    } catch (e) {
  console.error(
    'ERROR COMPLETO AL APLICAR PAGO:',
    e
  );

  alert(
    e.message ||
      'No se pudo registrar el pago.'
  );
} finally {
      setSaving(false);
    }
  };

  // ---------- RENDER ----------
  const pagPend = useMemo(() => pagosProgramados, [pagosProgramados]); // (se renderiza completo aquí)
  const historialPagosOrdenado = useMemo(() => {
  const lista = [...historialPagosSocio];

  lista.sort((a, b) => {
    let valorA;
    let valorB;

    if (ordenHistorial.campo === 'prestamo') {
      valorA = Number(a.id_prestamo || 0);
      valorB = Number(b.id_prestamo || 0);
    } else {
      valorA = new Date(
        a.fecha_hora_pago ||
        a.fecha_pago ||
        a.fecha_programada ||
        0
      ).getTime();

      valorB = new Date(
        b.fecha_hora_pago ||
        b.fecha_pago ||
        b.fecha_programada ||
        0
      ).getTime();
    }

    if (valorA === valorB) {
      return Number(a.numero_pago || 0) -
        Number(b.numero_pago || 0);
    }

    if (ordenHistorial.direccion === 'asc') {
      return valorA > valorB ? 1 : -1;
    }

    return valorA < valorB ? 1 : -1;
  });

  return lista;
}, [historialPagosSocio, ordenHistorial]);
const pagosVencidosAgrupados = useMemo(() => {
  const sociosMap = new Map();

  pagosVencidosList.forEach((pago) => {
    const socio = pago.socio;
    const prestamo = pago.prestamo;

    const idSocio =
      pago.id_socio ||
      prestamo?.id_socio ||
      'sin-socio';

    const socioKey = String(idSocio);

    if (!sociosMap.has(socioKey)) {
      sociosMap.set(socioKey, {
        id_socio: idSocio,
        socio,
        prestamos: new Map(),
      });
    }

    const grupoSocio = sociosMap.get(socioKey);

    const prestamoKey = String(
      pago.id_prestamo || 'sin-prestamo'
    );

    if (!grupoSocio.prestamos.has(prestamoKey)) {
      grupoSocio.prestamos.set(prestamoKey, {
        id_prestamo: pago.id_prestamo,
        prestamo,
        pagos: [],
        total_vencido: 0,
      });
    }

    const grupoPrestamo =
      grupoSocio.prestamos.get(prestamoKey);

    grupoPrestamo.pagos.push(pago);

    grupoPrestamo.total_vencido += Number(
      pago.monto_pago || 0
    );
  });

  return Array.from(sociosMap.values()).map(
    (grupoSocio) => ({
      ...grupoSocio,
      prestamos: Array.from(
        grupoSocio.prestamos.values()
      ),
    })
  );
}, [pagosVencidosList]);
  return (
    <div className="p-6 space-y-6">
      {/* Encabezado y tarjetas (SIN CAMBIOS) */}
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-2xl font-bold text-slate-900 mb-2">Pagos</h2>
          <p className="text-slate-600">Consulta el detalle de pago de los socios</p>
        </div>
  </div>
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        <div className="bg-white rounded-2xl border border-slate-200 p-6">
          <div className="flex items-center space-x-3 mb-2">
            <div className="w-10 h-10 bg-red-100 rounded-xl flex items-center justify-center"><span className="text-red-600">⏲️</span></div>
            <div>
              <h3 className="font-semibold text-slate-900">Pendientes del día</h3>
              <p className="text-2xl font-bold text-red-600">{pendientesHoy}</p>
              {dashError && <p className="text-xs text-red-500">{dashError}</p>}
            </div>
          </div>
        </div>

        <div className="bg-white rounded-2xl border border-slate-200 p-6">
          <div className="flex items-center space-x-3 mb-2">
            <div className="w-10 h-10 bg-yellow-100 rounded-xl flex items-center justify-center"><span className="text-yellow-600">📅</span></div>
            <div>
              <h3 className="font-semibold text-slate-900">Próximos pagos</h3>
              <p className="text-2xl font-bold text-yellow-600">{proximos}</p>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-2xl border border-slate-200 p-6">
          <div className="flex items-center space-x-3 mb-2">
            <div className="w-10 h-10 bg-green-100 rounded-xl flex items-center justify-center"><span className="text-green-600">💵</span></div>
            <div>
              <h3 className="font-semibold text-slate-900">Total recibido hoy</h3>
              <p className="text-2xl font-bold text-green-600">{fmtMoney(recibidosHoyMonto)}</p>
              <p className="text-sm text-slate-600">{recibidosHoyCount} pagos</p>
            </div>
          </div>
        </div>

      <button
  type="button"
  onClick={abrirPagosVencidos}
  className="
    w-full
    text-left
    bg-white
    rounded-2xl
    border
    border-slate-200
    p-6
    hover:border-purple-400
    hover:shadow-md
    transition-all
    cursor-pointer
  "
>
  <div className="flex items-center space-x-3 mb-2">
    <div className="w-10 h-10 bg-purple-100 rounded-xl flex items-center justify-center">
      <span className="text-purple-600">
        ⏰
      </span>
    </div>

    <div>
      <h3 className="font-semibold text-slate-900">
        Pagos vencidos
      </h3>

      <p className="text-2xl font-bold text-purple-600">
        {vencidos}
      </p>

      <p className="text-xs text-purple-600 mt-1">
        Clic para consultar
      </p>
    </div>
  </div>
</button>
      </div>

      {/* === BUSCAR SOCIO (solo input + flujo Prestamos/Pago) === */}
      <div className="bg-white rounded-2xl border border-slate-200 p-6">
        <h3 className="text-lg font-semibold text-slate-900 mb-3">Buscar Socio</h3>

        <div className="grid grid-cols-1 md:grid-cols-1 gap-3 items-center">
          <input
               ref={buscarSocioRef}
            type="text"
            className="px-4 py-2 bg-slate-50 border border-slate-200 rounded-xl"
            placeholder="ID o Nombre completo…"
            value={buscarSocioTerm}
            onChange={(e) => { setBuscarSocioTerm(e.target.value); setSocioSel(null); setPrestamosSocio([]); setPrestamoSel(null); }}
          />
        </div>

        {sugSocios.length > 0 && (
          <div className="mt-3 space-y-2">
            {sugSocios.map(s => (
              <div key={s.id_socio} className="p-2 bg-slate-50 rounded-lg flex justify-between">
                <span>ID: {s.id_socio} — {s.nombre} {s.apellido_paterno} {s.apellido_materno}</span>
                <button
                  className="px-3 py-1 bg-emerald-600 text-white rounded-lg"
                  onClick={() => {
                    setSocioSel(s);
                    setBuscarSocioTerm(`ID: ${s.id_socio} — ${s.nombre} ${s.apellido_paterno} ${s.apellido_materno}`);
                    setSugSocios([]);
                    setPrestamosSocio([]);
                    setPrestamoSel(null);
                  }}
                >
                  Seleccionar
                </button>
              </div>
            ))}
          </div>
        )}

       <div className="mt-4 flex flex-col sm:flex-row gap-3">
  <button
    type="button"
    className={`w-full sm:w-auto px-4 py-2 rounded-xl text-white ${
      socioSel
        ? 'bg-blue-600 hover:bg-blue-700'
        : 'bg-slate-400 cursor-not-allowed'
    }`}
    disabled={!socioSel}
    onClick={verPrestamos}
  >
    Ver Préstamos
  </button>

  <button
    type="button"
    className={`w-full sm:w-auto px-4 py-2 rounded-xl text-white ${
      socioSel
        ? 'bg-purple-600 hover:bg-purple-700'
        : 'bg-slate-400 cursor-not-allowed'
    }`}
    disabled={!socioSel}
    onClick={abrirHistorialPagosSocio}
  >
    Ver Historial de Pagos
  </button>
</div>

        {prestamosSocio.length > 0 && (
          <div className="mt-4">
            <h4 className="font-semibold text-slate-900 mb-2">Préstamos de {socioSel?.nombre} {socioSel?.apellido_paterno}</h4>
            <div className="space-y-2">
              {prestamosSocio.map(p => (
                <label key={p.id_prestamo} className="flex items-center justify-between p-3 bg-slate-50 rounded-lg border">
                  <div className="flex items-center gap-3">
                    <input
                      type="radio"
                      name="prestamoSel"
                      checked={prestamoSel?.id_prestamo === p.id_prestamo}
                      onChange={() => setPrestamoSel(p)}
                    />
                    <span className="font-medium">
                      Préstamo #{p.id_prestamo} — {fmtMoney(p.monto_solicitado)} — {p.tipo_plazo} — {p.numero_plazos} plazos — Tasa {p.interes}%
                    </span>
                    {/* === NUEVO: Leyenda si está liquidado === */}
                    {p.isLiquidado && (
                      <span className="ml-2 px-2 py-0.5 text-xs rounded-full bg-blue-100 text-blue-700">
                        Préstamo Liquidado
                      </span>
                    )}
                  </div>
                </label>
              ))}
            </div>

           <div className="mt-4 flex flex-col sm:flex-row gap-3">
  <button
    type="button"
    className={`w-full sm:w-auto px-4 py-2 rounded-xl text-white ${
      prestamoSel
        ? 'bg-emerald-600 hover:bg-emerald-700'
        : 'bg-slate-400 cursor-not-allowed'
    }`}
    disabled={!prestamoSel}
    onClick={abrirRealizarPago}
  >
    Realizar pago
  </button>

  <button
    type="button"
    className="w-full sm:w-auto px-4 py-2 rounded-xl text-white bg-purple-600 hover:bg-purple-700"
    onClick={abrirHistorialPagosSocio}
  >
    Ver Historial de Pagos
  </button>
</div>
          </div>
        )}
      </div>

{/* MODAL: PAGOS VENCIDOS AGRUPADOS */}
{showVencidosModal && (
  <div className="fixed inset-0 bg-black/50 z-[60] flex items-center justify-center p-3 md:p-4">
    <div className="bg-white rounded-2xl shadow-xl w-full max-w-6xl max-h-[94vh] md:max-h-[90vh] overflow-hidden">
      {/* Encabezado */}
      <div className="flex items-center justify-between gap-3 p-4 md:p-5 border-b border-slate-200">
        <div>
          <h3 className="text-lg md:text-xl font-bold text-slate-900">
            Pagos vencidos
          </h3>

          <p className="text-sm text-slate-600">
            {pagosVencidosList.length}{' '}
            pago(s) vencido(s) de{' '}
            {pagosVencidosAgrupados.length}{' '}
            socio(s)
          </p>
        </div>

        <button
          type="button"
          onClick={() => {
            setShowVencidosModal(false);
            setPrestamoVencidoAbierto(null);
            setDetalleVencidoAbierto(null);
          }}
          className="shrink-0 px-3 py-2 bg-slate-100 text-slate-700 rounded-lg hover:bg-slate-200"
        >
          Cerrar
        </button>
      </div>

      {/* Contenido */}
      <div className="p-3 md:p-5 max-h-[82vh] md:max-h-[78vh] overflow-y-auto">
        {loadingVencidos && (
          <p className="text-center text-slate-600 py-8">
            Cargando pagos vencidos...
          </p>
        )}

        {!loadingVencidos && errorVencidos && (
          <div className="bg-red-50 border border-red-200 text-red-700 rounded-xl p-4">
            {errorVencidos}
          </div>
        )}

        {!loadingVencidos &&
          !errorVencidos &&
          pagosVencidosAgrupados.length === 0 && (
            <p className="text-center text-slate-600 py-8">
              No existen pagos vencidos.
            </p>
          )}

        {!loadingVencidos &&
          !errorVencidos &&
          pagosVencidosAgrupados.length > 0 && (
            <div className="space-y-4">
              {pagosVencidosAgrupados.map(
                (grupoSocio) => {
                  const socio = grupoSocio.socio;

                  const nombreCompleto = socio
                    ? `${socio.nombre || ''} ${
                        socio.apellido_paterno || ''
                      } ${
                        socio.apellido_materno || ''
                      }`.trim()
                    : 'SOCIO NO IDENTIFICADO';

                  const totalSocio =
                    grupoSocio.prestamos.reduce(
                      (suma, prestamo) =>
                        suma +
                        Number(
                          prestamo.total_vencido || 0
                        ),
                      0
                    );

                  return (
                    <div
                      key={String(
                        grupoSocio.id_socio
                      )}
                      className="border border-slate-200 rounded-2xl overflow-hidden bg-white"
                    >
                      {/* Cabecera del socio */}
                      <div className="p-4 bg-slate-50 border-b border-slate-200">
                        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3">
                          <div>
                            <p className="text-xs font-medium text-slate-500">
                              SOCIO
                            </p>

                            <h4 className="text-base md:text-lg font-bold text-slate-900">
                              {nombreCompleto}
                            </h4>

                            <p className="text-sm text-slate-500">
                              ID:{' '}
                              {grupoSocio.id_socio ||
                                '—'}
                            </p>
                          </div>

                          <div className="md:text-right">
                            <p className="text-xs text-slate-500">
                              Total vencido
                            </p>

                            <p className="text-xl font-bold text-red-600">
                              {fmtMoney(totalSocio)}
                            </p>

                            <p className="text-xs text-slate-500">
                              {
                                grupoSocio.prestamos
                                  .length
                              }{' '}
                              préstamo(s)
                            </p>
                          </div>
                        </div>
                      </div>

                      {/* Préstamos del socio */}
                      <div className="p-3 md:p-4 space-y-3">
                        {grupoSocio.prestamos.map(
                          (grupoPrestamo) => {
                            const clavePrestamo =
                              `${grupoSocio.id_socio}-${grupoPrestamo.id_prestamo}`;

                            const abierto =
                              prestamoVencidoAbierto ===
                              clavePrestamo;

                            return (
                              <div
                                key={clavePrestamo}
                                className="border border-slate-200 rounded-xl overflow-hidden"
                              >
                                {/* Resumen del préstamo */}
                                <div className="p-3 md:p-4">
                                  <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3">
                                    <div>
                                      <p className="text-xs text-slate-500">
                                        Préstamo
                                      </p>

                                      <p className="font-bold text-slate-900">
                                        #
                                        {
                                          grupoPrestamo.id_prestamo
                                        }
                                      </p>

                                      <p className="text-sm text-slate-600">
                                        {
                                          grupoPrestamo
                                            .pagos.length
                                        }{' '}
                                        pago(s) vencido(s)
                                      </p>
                                    </div>

                                    <div className="flex flex-col md:flex-row md:items-center gap-3">
                                      <div className="md:text-right">
                                        <p className="text-xs text-slate-500">
                                          Total pendiente
                                        </p>

                                        <p className="font-bold text-purple-600">
                                          {fmtMoney(
                                            grupoPrestamo.total_vencido
                                          )}
                                        </p>
                                      </div>

                                      <button
                                        type="button"
                                        onClick={() => {
                                          setPrestamoVencidoAbierto(
                                            abierto
                                              ? null
                                              : clavePrestamo
                                          );

                                          setDetalleVencidoAbierto(
                                            null
                                          );
                                        }}
                                        className="w-full md:w-auto px-4 py-2 bg-purple-600 text-white rounded-lg text-sm font-medium hover:bg-purple-700"
                                      >
                                        {abierto
                                          ? 'Ocultar pagos'
                                          : 'Ver pagos'}
                                      </button>
                                    </div>
                                  </div>
                                </div>

                                {/* Pagos vencidos del préstamo */}
                                {abierto && (
                                  <div className="border-t border-slate-200 bg-purple-50/40 p-3 md:p-4">
                                    {/* Aplicación móvil */}
                                    <div className="md:hidden space-y-3">
                                      {grupoPrestamo.pagos.map(
                                        (pago) => {
                                          const detalleAbierto =
                                            detalleVencidoAbierto ===
                                            pago.id_pago;

                                          return (
                                            <div
                                              key={
                                                pago.id_pago
                                              }
                                              className="bg-white border border-slate-200 rounded-xl p-4 space-y-3"
                                            >
                                              <div className="flex items-center justify-between gap-3">
                                                <div>
                                                  <p className="text-xs text-slate-500">
                                                    Número de pago
                                                  </p>

                                                  <p className="font-bold text-slate-900">
                                                    #
                                                    {
                                                      pago.numero_pago
                                                    }
                                                  </p>
                                                </div>

                                                <span className="px-3 py-1 bg-red-100 text-red-700 rounded-full text-xs font-medium">
                                                  Vencido
                                                </span>
                                              </div>

                                              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                                                <div>
                                                  <p className="text-xs text-slate-500">
                                                    Fecha
                                                  </p>

                                                  <p className="font-medium text-red-600">
                                                    {fmtLongDate(
                                                      pago.fecha_programada
                                                    )}
                                                  </p>
                                                </div>

                                                <div>
                                                  <p className="text-xs text-slate-500">
                                                    Monto
                                                  </p>

                                                  <p className="font-bold text-purple-600">
                                                    {fmtMoney(
                                                      pago.monto_pago
                                                    )}
                                                  </p>
                                                </div>
                                              </div>

                                              <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                                                <button
                                                  type="button"
                                                  onClick={() =>
                                                    setDetalleVencidoAbierto(
                                                      detalleAbierto
                                                        ? null
                                                        : pago.id_pago
                                                    )
                                                  }
                                                  className="w-full px-4 py-2 bg-slate-200 text-slate-800 rounded-lg font-medium hover:bg-slate-300"
                                                >
                                                  {detalleAbierto
                                                    ? 'Ocultar detalles'
                                                    : 'Ver detalles'}
                                                </button>

                                                <button
                                                  type="button"
                                                  onClick={() =>
                                                    pagarDesdeVencidos(
                                                      pago
                                                    )
                                                  }
                                                  className="w-full px-4 py-2 bg-emerald-600 text-white rounded-lg font-medium hover:bg-emerald-700"
                                                >
                                                  Pagar
                                                </button>
                                              </div>

                                              {detalleAbierto && (
                                                <div className="bg-slate-50 border border-slate-200 rounded-xl p-3 space-y-2 text-sm">
                                                  <p>
                                                    <strong>
                                                      Socio:
                                                    </strong>{' '}
                                                    {
                                                      nombreCompleto
                                                    }
                                                  </p>

                                                  <p>
                                                    <strong>
                                                      Préstamo:
                                                    </strong>{' '}
                                                    #
                                                    {
                                                      pago.id_prestamo
                                                    }
                                                  </p>

                                                  <p>
                                                    <strong>
                                                      Pago:
                                                    </strong>{' '}
                                                    #
                                                    {
                                                      pago.numero_pago
                                                    }
                                                  </p>

                                                  <p>
                                                    <strong>
                                                      Teléfono:
                                                    </strong>{' '}
                                                    {socio?.telefono ||
                                                      '—'}
                                                  </p>

                                                  <p>
                                                    <strong>
                                                      Correo:
                                                    </strong>{' '}
                                                    {socio?.email ||
                                                      '—'}
                                                  </p>
                                                </div>
                                              )}
                                            </div>
                                          );
                                        }
                                      )}
                                    </div>

                                    {/* Escritorio */}
                                    <div className="hidden md:block overflow-x-auto">
                                      <table className="w-full">
                                        <thead>
                                          <tr className="border-b border-slate-200">
                                            <th className="text-left py-3 px-3">
                                              Pago
                                            </th>

                                            <th className="text-left py-3 px-3">
                                              Fecha vencida
                                            </th>

                                            <th className="text-left py-3 px-3">
                                              Monto
                                            </th>

                                            <th className="text-left py-3 px-3">
                                              Estatus
                                            </th>

                                            <th className="text-left py-3 px-3">
                                              Acciones
                                            </th>
                                          </tr>
                                        </thead>

                                        <tbody>
                                          {grupoPrestamo.pagos.map(
                                            (pago) => {
                                              const detalleAbierto =
                                                detalleVencidoAbierto ===
                                                pago.id_pago;

                                              return (
                                                <React.Fragment
                                                  key={
                                                    pago.id_pago
                                                  }
                                                >
                                                  <tr className="border-b border-slate-100 bg-white">
                                                    <td className="py-3 px-3 font-medium">
                                                      #
                                                      {
                                                        pago.numero_pago
                                                      }
                                                    </td>

                                                    <td className="py-3 px-3 text-red-600 font-medium">
                                                      {fmtLongDate(
                                                        pago.fecha_programada
                                                      )}
                                                    </td>

                                                    <td className="py-3 px-3 font-bold text-purple-600">
                                                      {fmtMoney(
                                                        pago.monto_pago
                                                      )}
                                                    </td>

                                                    <td className="py-3 px-3">
                                                      <span className="px-3 py-1 bg-red-100 text-red-700 rounded-full text-xs font-medium">
                                                        VENCIDO
                                                      </span>
                                                    </td>

                                                    <td className="py-3 px-3">
                                                      <div className="flex gap-2">
                                                        <button
                                                          type="button"
                                                          onClick={() =>
                                                            setDetalleVencidoAbierto(
                                                              detalleAbierto
                                                                ? null
                                                                : pago.id_pago
                                                            )
                                                          }
                                                          className="px-3 py-2 bg-slate-200 text-slate-800 rounded-lg text-sm hover:bg-slate-300"
                                                        >
                                                          {detalleAbierto
                                                            ? 'Ocultar'
                                                            : 'Ver detalles'}
                                                        </button>

                                                        <button
                                                          type="button"
                                                          onClick={() =>
                                                            pagarDesdeVencidos(
                                                              pago
                                                            )
                                                          }
                                                          className="px-3 py-2 bg-emerald-600 text-white rounded-lg text-sm hover:bg-emerald-700"
                                                        >
                                                          Pagar
                                                        </button>
                                                      </div>
                                                    </td>
                                                  </tr>

                                                  {detalleAbierto && (
                                                    <tr className="bg-slate-50">
                                                      <td
                                                        colSpan="5"
                                                        className="px-4 py-4"
                                                      >
                                                        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 text-sm">
                                                          <div>
                                                            <p className="text-slate-500">
                                                              Socio
                                                            </p>

                                                            <p className="font-medium text-slate-900">
                                                              {
                                                                nombreCompleto
                                                              }
                                                            </p>
                                                          </div>

                                                          <div>
                                                            <p className="text-slate-500">
                                                              Teléfono
                                                            </p>

                                                            <p className="font-medium text-slate-900">
                                                              {socio?.telefono ||
                                                                '—'}
                                                            </p>
                                                          </div>

                                                          <div>
                                                            <p className="text-slate-500">
                                                              Correo
                                                            </p>

                                                            <p className="font-medium text-slate-900">
                                                              {socio?.email ||
                                                                '—'}
                                                            </p>
                                                          </div>

                                                          <div>
                                                            <p className="text-slate-500">
                                                              Préstamo
                                                            </p>

                                                            <p className="font-medium text-slate-900">
                                                              #
                                                              {
                                                                pago.id_prestamo
                                                              }
                                                            </p>
                                                          </div>
                                                        </div>
                                                      </td>
                                                    </tr>
                                                  )}
                                                </React.Fragment>
                                              );
                                            }
                                          )}
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                )}
                              </div>
                            );
                          }
                        )}
                      </div>
                    </div>
                  );
                }
              )}
            </div>
          )}
      </div>
    </div>
  </div>
)}

      {/* MODAL: pagos programados del préstamo */}
      {showPagoModal && (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-start justify-center p-4">
          <div className="bg-white rounded-2xl w-full max-w-5xl shadow-xl">
            <div className="flex items-center justify-between p-4 border-b">
              <h3 className="text-lg font-semibold">
                Pagos programados — Préstamo #{prestamoSel?.id_prestamo}
              </h3>
              <button className="px-3 py-1 rounded-lg bg-slate-100" onClick={() => setShowPagoModal(false)}>Cerrar</button>
            </div>

          <div className="p-4 max-h-[78vh] overflow-y-auto">
              {(!pagosProgramados || pagosProgramados.length === 0) ? (
                <p className="text-slate-600">Sin pagos programados.</p>
              ) : (
    <>
  {/* Vista móvil */}
  <div className="md:hidden space-y-3">
    {pagosProgramados.map((row) => {
      const fechaTxt = row.fecha_hora_pago
        ? fmt12h(row.fecha_hora_pago)
        : row.fecha_pago || '—';

      const isPagado =
        (row.estatus || '').toLowerCase() === 'pagado';

      return (
        <div
          key={row.id_pago}
          className="border border-slate-200 rounded-xl p-4 bg-slate-50 space-y-3"
        >
          <div className="flex items-center justify-between">
            <div>
              <p className="text-xs text-slate-500">Pago</p>
              <p className="font-bold text-slate-900">
                #{row.numero_pago}
              </p>
            </div>

            <span
              className={`px-3 py-1 rounded-full text-xs font-medium ${
                isPagado
                  ? 'bg-green-100 text-green-700'
                  : 'bg-yellow-100 text-yellow-700'
              }`}
            >
              {isPagado ? 'Pagado' : 'Pendiente'}
            </span>
          </div>

          <div>
            <p className="text-xs text-slate-500">
              Fecha programada
            </p>
            <p className="font-medium text-slate-900">
              {fmtLongDate(row.fecha_programada)}
            </p>
          </div>

          <div>
            <p className="text-xs text-slate-500">
              Monto a pagar
            </p>
            <p className="text-lg font-bold text-blue-600">
              {fmtMoney(row.monto_pago)}
            </p>
          </div>

          <div className="grid grid-cols-2 gap-3">
            <div>
              <p className="text-xs text-slate-500">Interés</p>
              <p className="font-medium text-slate-900">
                {row.interes_pagado != null
                  ? fmtMoney(row.interes_pagado)
                  : '—'}
              </p>
            </div>

            <div>
              <p className="text-xs text-slate-500">Capital</p>
              <p className="font-medium text-slate-900">
                {row.capital_pagado != null
                  ? fmtMoney(row.capital_pagado)
                  : '—'}
              </p>
            </div>
          </div>

          <div>
            <p className="text-xs text-slate-500">
              Fecha/Hora de pago
            </p>
            <p className="font-medium text-slate-900">
              {fechaTxt}
            </p>
          </div>

          <div>
            <p className="text-xs text-slate-500">
              Forma de pago
            </p>
            <p className="font-medium text-slate-900">
              {row.forma_pago || '—'}
            </p>
          </div>

          {row.nota && (
            <button
              type="button"
              className="w-full px-3 py-2 bg-slate-200 rounded-lg text-sm font-medium hover:bg-slate-300"
              onClick={() => {
                setNotaTexto(row.nota);
                setShowNotaModal(true);
              }}
            >
              Ver nota
            </button>
          )}

          {!isPagado && (
            <button
              type="button"
              className="w-full px-4 py-2 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700"
              onClick={() => onClickRealizarPagoFila(row)}
            >
              Realizar pago
            </button>
          )}
        </div>
      );
    })}
  </div>

  {/* Vista escritorio */}
  <div className="hidden md:block overflow-x-auto">
    <table className="w-full">
      <thead>
        <tr className="border-b border-slate-200">
          <th className="text-left py-2 px-3">No</th>
          <th className="text-left py-2 px-3">
            Fecha programada
          </th>
          <th className="text-left py-2 px-3">
            Monto a pagar
          </th>
          <th className="text-left py-2 px-3">Interés</th>
          <th className="text-left py-2 px-3">Capital</th>
          <th className="text-left py-2 px-3">
            Fecha/Hora pago
          </th>
          <th className="text-left py-2 px-3">
            Forma de pago
          </th>
          <th className="text-left py-2 px-3">Nota</th>
          <th className="text-left py-2 px-3">Estatus</th>
          <th className="text-left py-2 px-3">Acción</th>
        </tr>
      </thead>

      <tbody>
        {pagosProgramados.map((row) => {
          const fechaTxt = row.fecha_hora_pago
            ? fmt12h(row.fecha_hora_pago)
            : row.fecha_pago || '—';

          const isPagado =
            (row.estatus || '').toLowerCase() === 'pagado';

          return (
            <tr
              key={row.id_pago}
              className="border-b border-slate-100"
            >
              <td className="py-2 px-3">
                {row.numero_pago}
              </td>

              <td className="py-2 px-3">
                {fmtLongDate(row.fecha_programada)}
              </td>

              <td className="py-2 px-3">
                {fmtMoney(row.monto_pago)}
              </td>

              <td className="py-2 px-3">
                {row.interes_pagado != null
                  ? fmtMoney(row.interes_pagado)
                  : '—'}
              </td>

              <td className="py-2 px-3">
                {row.capital_pagado != null
                  ? fmtMoney(row.capital_pagado)
                  : '—'}
              </td>

              <td className="py-2 px-3">
                {fechaTxt}
              </td>

              <td className="py-2 px-3">
                {row.forma_pago || '—'}
              </td>

              <td className="py-2 px-3">
                {row.nota ? (
                  <button
                    className="px-3 py-1 bg-slate-200 rounded-lg hover:bg-slate-300"
                    onClick={() => {
                      setNotaTexto(row.nota);
                      setShowNotaModal(true);
                    }}
                  >
                    Ver nota
                  </button>
                ) : (
                  '—'
                )}
              </td>

              <td className="py-2 px-3">
                {isPagado ? 'pagado' : 'pendiente'}
              </td>

              <td className="py-2 px-3">
                {!isPagado && (
                  <button
                    className="px-3 py-1 bg-blue-600 text-white rounded-lg"
                    onClick={() =>
                      onClickRealizarPagoFila(row)
                    }
                  >
                    Realizar pago
                  </button>
                )}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  </div>
</>
              )}
            </div>
          </div>
        </div>
      )}

      {/* SUB-MODAL: ingresar monto + forma de pago + nota + (NUEVO) Multa por hoja */}
      {showMontoModal && pagoTarget && (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-2xl w-full max-w-md shadow-xl p-5">
            <h3 className="text-lg font-semibold mb-3">Realizar pago — # {pagoTarget.numero_pago}</h3>
            <div className="space-y-4">
              <div>
                <label className="block text-sm text-slate-700 mb-1">Monto a pagar</label>
                <input
                  type="number"
                  min="0"
                  step="0.01"
                  className="w-full px-3 py-2 border rounded-lg"
                  value={montoIngresado}
                  onChange={(e) => setMontoIngresado(e.target.value)}
                />
              </div>

              <div>
                <p className="block text-sm text-slate-700 mb-2">Seleccione la forma de pago</p>
                <div className="flex items-center gap-4">
                  <label className="flex items-center gap-2">
                    <input
                      type="radio"
                      name="forma_pago"
                      value="Efectivo"
                      checked={formaPago === 'Efectivo'}
                      onChange={(e) => { setFormaPago(e.target.value); setFormaPagoError(''); }}
                    />
                    Efectivo
                  </label>
                  <label className="flex items-center gap-2">
                    <input
                      type="radio"
                      name="forma_pago"
                      value="Transferencia"
                      checked={formaPago === 'Transferencia'}
                      onChange={(e) => { setFormaPago(e.target.value); setFormaPagoError(''); }}
                    />
                    Transferencia
                  </label>
                </div>
                {formaPagoError && <p className="text-red-600 text-sm mt-1">{formaPagoError}</p>}
              </div>

              {/* NUEVO: Multa por hoja */}
              <div>
                <p className="block text-sm text-slate-700 mb-2">Multa por hoja</p>
                <div className="flex items-center gap-4">
                  <label className="flex items-center gap-2">
                    <input
                      type="radio"
                      name="multa_hoja"
                      value="no"
                      checked={multaHoja === 'no'}
                      onChange={(e) => { setMultaHoja(e.target.value); setMontoMultaHoja(''); }}
                    />
                    No
                  </label>
                  <label className="flex items-center gap-2">
                    <input
                      type="radio"
                      name="multa_hoja"
                      value="si"
                      checked={multaHoja === 'si'}
                      onChange={(e) => setMultaHoja(e.target.value)}
                    />
                    Sí
                  </label>
                </div>

                {multaHoja === 'si' && (
                  <div className="mt-3">
                    <label className="block text-sm text-slate-700 mb-1">Monto de la multa</label>
                    <input
                      type="number"
                      min="0"
                      step="0.01"
                      className="w-full px-3 py-2 border rounded-lg"
                      value={montoMultaHoja}
                      onChange={(e) => setMontoMultaHoja(e.target.value)}
                      placeholder="0.00"
                    />
                  </div>
                )}
              </div>
              {/* FIN NUEVO */}

              <div>
                <label className="block text-sm text-slate-700 mb-1">Nota (opcional)</label>
                <textarea
                  className="w-full px-3 py-2 border rounded-lg"
                  rows="3"
                  placeholder="Ej: transferencia realizada el 10/Octubre/2025 con referencia 123456789"
                  value={nota}
                  onChange={(e) => setNota(e.target.value)}
                />
              </div>

              <div className="flex justify-end gap-2 pt-2">
                <button className="px-4 py-2 rounded-lg bg-slate-100" onClick={() => { setShowMontoModal(false); setPagoTarget(null); }}>Cancelar</button>
                <button className="px-4 py-2 rounded-lg bg-emerald-600 text-white" onClick={aplicarPago}>Aplicar pago</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* CONFIRMACIÓN FINAL */}
      {showConfirm && (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-2xl w-full max-w-md shadow-xl p-5 text-center">
            <h3 className="text-lg font-semibold mb-3">¿Está seguro que desea aplicar el pago ahora?</h3>
            <p className="text-slate-700 mb-5">Se registrará el pago con el monto indicado.</p>
            <div className="flex justify-center gap-3">
              <button
                className="px-4 py-2 rounded-lg bg-slate-100"
                onClick={() => setShowConfirm(false)}
                disabled={saving}
              >
                Cancelar
              </button>
              <button
                className={`px-4 py-2 rounded-lg text-white ${saving ? 'bg-emerald-400 cursor-wait' : 'bg-emerald-600 hover:bg-emerald-700'}`}
                onClick={confirmarAplicacionPago}
                disabled={saving}
              >
                {saving ? 'Aplicando…' : 'Aceptar'}
              </button>
            </div>
          </div>
        </div>
      )}

{/* MODAL: HISTORIAL DE PAGOS DEL SOCIO */}
{showHistorialPagosModal && (
  <div className="fixed inset-0 bg-black/50 z-[70] flex items-center justify-center p-3 md:p-4">
    <div className="bg-white rounded-2xl shadow-xl w-full max-w-6xl max-h-[94vh] overflow-hidden">
      {/* Encabezado */}
      <div className="flex items-center justify-between gap-3 p-4 md:p-5 border-b border-slate-200">
        <div>
          <h3 className="text-lg md:text-xl font-bold text-slate-900">
            Historial de pagos
          </h3>

          <p className="text-sm text-slate-600">
            {socioSel?.nombre}{' '}
            {socioSel?.apellido_paterno}{' '}
            {socioSel?.apellido_materno}
          </p>

          <p className="text-xs text-slate-500">
            ID Socio: {socioSel?.id_socio}
          </p>
        </div>

        <button
          type="button"
          onClick={() => {
            setShowHistorialPagosModal(false);
            setHistorialPagosSocio([]);
            setErrorHistorialPagos('');
          }}
          className="shrink-0 px-3 py-2 bg-slate-100 text-slate-700 rounded-lg hover:bg-slate-200"
        >
          Cerrar
        </button>
      </div>

      <div className="p-3 md:p-5 max-h-[82vh] overflow-y-auto">
        {loadingHistorialPagos && (
          <p className="text-center text-slate-600 py-8">
            Cargando historial de pagos...
          </p>
        )}

        {!loadingHistorialPagos &&
          errorHistorialPagos && (
            <div className="bg-red-50 border border-red-200 text-red-700 rounded-xl p-4">
              {errorHistorialPagos}
            </div>
          )}

        {!loadingHistorialPagos &&
          !errorHistorialPagos &&
          historialPagosSocio.length === 0 && (
            <div className="text-center py-10">
              <p className="font-semibold text-slate-800">
                Este socio aún no tiene pagos registrados.
              </p>

              <p className="text-sm text-slate-500 mt-1">
                Los pagos realizados aparecerán aquí.
              </p>
            </div>
          )}

        {!loadingHistorialPagos &&
          !errorHistorialPagos &&
          historialPagosSocio.length > 0 && (
            <>
              {/* Resumen */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-5">
                <div className="bg-purple-50 border border-purple-200 rounded-xl p-4">
                  <p className="text-sm text-slate-600">
                    Pagos realizados
                  </p>

                  <p className="text-2xl font-bold text-purple-700">
                    {historialPagosSocio.length}
                  </p>
                </div>

                <div className="bg-green-50 border border-green-200 rounded-xl p-4">
                  <p className="text-sm text-slate-600">
                    Total pagado
                  </p>

                  <p className="text-2xl font-bold text-green-700">
                    {fmtMoney(
                      historialPagosSocio.reduce(
                        (total, pago) =>
                          total +
                          Number(
                            pago.monto_pagado || 0
                          ),
                        0
                      )
                    )}
                  </p>
                </div>
              </div>

              {/* Vista móvil */}
             <div className="md:hidden">

  <div className="grid grid-cols-2 gap-2 mb-3">

    <button
      type="button"
      onClick={() => cambiarOrdenHistorial('prestamo')}
      className="px-3 py-2 rounded-lg border bg-white text-sm"
    >
      Préstamo {ordenHistorial.campo === 'prestamo'
        ? ordenHistorial.direccion === 'asc'
          ? '▲'
          : '▼'
        : '↕'}
    </button>

    <button
      type="button"
      onClick={() => cambiarOrdenHistorial('fecha')}
      className="px-3 py-2 rounded-lg border bg-white text-sm"
    >
      Fecha {ordenHistorial.campo === 'fecha'
        ? ordenHistorial.direccion === 'asc'
          ? '▲'
          : '▼'
        : '↕'}
    </button>

  </div>

  <div className="space-y-3">
               {historialPagosOrdenado.map((pago) => {
                  const fechaPago =
  pago.fecha_hora_pago
    ? fmtFechaHoraLarga(
        pago.fecha_hora_pago
      )
    : pago.fecha_pago
      ? fmtLongDate(
          pago.fecha_pago
        )
      : '—';

                  return (
                    <div
                      key={pago.id_pago}
                      className="bg-slate-50 border border-slate-200 rounded-xl p-4 space-y-3"
                    >
                      <div className="flex items-start justify-between gap-3">
                        <div>
                          <p className="text-xs text-slate-500">
                            Préstamo
                          </p>

                          <p className="font-bold text-slate-900">
                            #{pago.id_prestamo}
                          </p>
                        </div>

                        <div className="text-right">
                          <p className="text-xs text-slate-500">
                            Pago
                          </p>

                          <p className="font-bold text-slate-900">
                            #{pago.numero_pago}
                          </p>
                        </div>
                      </div>

                      <div>
                        <p className="text-xs text-slate-500">
                          Fecha y hora
                        </p>

                        <p className="font-medium text-slate-900">
                          {fechaPago}
                        </p>
                      </div>

                      <div>
                        <p className="text-xs text-slate-500">
                          Monto pagado
                        </p>

                        <p className="text-xl font-bold text-green-700">
                          {fmtMoney(pago.monto_pagado)}
                        </p>
                      </div>

                      <div className="grid grid-cols-2 gap-3">
                        <div>
                          <p className="text-xs text-slate-500">
                            Interés
                          </p>

                          <p className="font-medium">
                            {fmtMoney(
                              pago.interes_pagado
                            )}
                          </p>
                        </div>

                        <div>
                          <p className="text-xs text-slate-500">
                            Capital
                          </p>

                          <p className="font-medium">
                            {fmtMoney(
                              pago.capital_pagado
                            )}
                          </p>
                        </div>
                      </div>

                      <div>
                        <p className="text-xs text-slate-500">
                          Forma de pago
                        </p>

                        <p className="font-medium">
                          {pago.forma_pago || '—'}
                        </p>
                      </div>

                      {pago.nota && (
                        <button
                          type="button"
                          onClick={() => {
                            setNotaTexto(pago.nota);
                            setShowNotaModal(true);
                          }}
                          className="w-full px-4 py-2 bg-slate-200 text-slate-800 rounded-lg font-medium hover:bg-slate-300"
                        >
                          Ver nota
                        </button>
                      )}
                    </div>
                  );
                })}
              </div>
 </div>

              {/* Vista web */}
              <div className="hidden md:block overflow-x-auto">
                <table className="w-full">
                  <thead>
                    <tr className="border-b border-slate-200">
                     <th className="text-left py-3 px-3">
  <button
    type="button"
    onClick={() =>
      cambiarOrdenHistorial('prestamo')
    }
    className="inline-flex items-center gap-2 font-semibold hover:text-purple-700"
  >
    Préstamo

    <span className="text-xs">
      {ordenHistorial.campo === 'prestamo'
        ? ordenHistorial.direccion === 'asc'
          ? '▲'
          : '▼'
        : '↕'}
    </span>
  </button>
</th>

                      <th className="text-left py-3 px-3">
                        Pago
                      </th>

                      <th className="text-left py-3 px-3">
  <button
    type="button"
    onClick={() =>
      cambiarOrdenHistorial('fecha')
    }
    className="inline-flex items-center gap-2 font-semibold hover:text-purple-700"
  >
    Fecha y hora

    <span className="text-xs">
      {ordenHistorial.campo === 'fecha'
        ? ordenHistorial.direccion === 'asc'
          ? '▲'
          : '▼'
        : '↕'}
    </span>
  </button>
</th>

                      <th className="text-left py-3 px-3">
                        Monto
                      </th>

                      <th className="text-left py-3 px-3">
                        Interés
                      </th>

                      <th className="text-left py-3 px-3">
                        Capital
                      </th>

                      <th className="text-left py-3 px-3">
                        Forma de pago
                      </th>

                      <th className="text-left py-3 px-3">
                        Nota
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {historialPagosOrdenado.map((pago) => {
                      const fechaPago =
                        pago.fecha_hora_pago
                          ? fmt12h(
                              pago.fecha_hora_pago
                            )
                          : pago.fecha_pago
                            ? fmtLongDate(
                                pago.fecha_pago
                              )
                            : '—';

                      return (
                        <tr
                          key={pago.id_pago}
                          className="border-b border-slate-100 hover:bg-slate-50"
                        >
                          <td className="py-3 px-3 font-medium">
                            #{pago.id_prestamo}
                          </td>

                          <td className="py-3 px-3">
                            #{pago.numero_pago}
                          </td>

                          <td className="py-3 px-3">
                            {fechaPago}
                          </td>

                          <td className="py-3 px-3 font-bold text-green-700">
                            {fmtMoney(
                              pago.monto_pagado
                            )}
                          </td>

                          <td className="py-3 px-3">
                            {fmtMoney(
                              pago.interes_pagado
                            )}
                          </td>

                          <td className="py-3 px-3">
                            {fmtMoney(
                              pago.capital_pagado
                            )}
                          </td>

                          <td className="py-3 px-3">
                            {pago.forma_pago || '—'}
                          </td>

                          <td className="py-3 px-3">
                            {pago.nota ? (
                              <button
                                type="button"
                                onClick={() => {
                                  setNotaTexto(
                                    pago.nota
                                  );

                                  setShowNotaModal(
                                    true
                                  );
                                }}
                                className="px-3 py-1 bg-slate-200 rounded-lg hover:bg-slate-300"
                              >
                                Ver nota
                              </button>
                            ) : (
                              '—'
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </>
          )}
      </div>
    </div>
  </div>
)}

      {/* MODAL: Ver nota */}
      {showNotaModal && (
        <div className="fixed inset-0 bg-black/50 z-[80] flex items-center justify-center p-4">
          <div className="bg-white rounded-2xl w-full max-w-lg shadow-xl p-5">
            <h3 className="text-lg font-semibold mb-3">Nota</h3>
            <div className="whitespace-pre-wrap text-slate-800 border rounded-lg p-3 bg-slate-50">
              {notaTexto}
            </div>
            <div className="flex justify-end mt-4">
              <button className="px-4 py-2 rounded-lg bg-slate-100" onClick={() => setShowNotaModal(false)}>Cerrar</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PagosModule;
